import React, {Component} from 'react';
//import flag from '../img/a.png';
class Support extends Component {
    
    
    render() {
       
            return (

<section className="pb-6">
    <div className="container">
        <div className="row">
            <div className="col-md-8 mx-auto">
                <h2 className="text-center text-md-left">Show your support!</h2>
                <p className="lead text-muted">Please ⭐️ this repository on github if this project helped you!</p>
                <div className="mt-5 d-flex flex-row justify-content-md-between flex-wrap press-icons">
                    <iframe src="https://ghbtns.com/github-btn.html?user=MohammedRaji&amp;repo=react-ig-feed&amp;type=star&amp;count=true&amp;size=large" frameBorder="0" scrolling="0" width="170" height="30" title="GitHub"></iframe>

                </div>
            </div>
        </div>
    </div>
</section>

                

            );

        }

    }


export default Support;

